import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ModEdges = (props) => {
    let {parameter, i, height, color, selectedEdge, setSelectedEdge} = props;
    if (parameter === undefined) {
        return [];
    }
    let edges = [];
    for (let lfo of parameter.lfos) {
        edges.push((
            <ModEdge {... props} modulator={lfo}/>));
    }
    for (let env of parameter.envelopes) {
        edges.push((
            <ModEdge {... props} modulator={env}/>));
    }
    return edges;
}

const ModEdge = ({modulator, parameter, i, height, color, setSelectedEdge, selectedEdge}) => {
    let x1 = 25 + i * 48;
    let y1 = 2;
    let factor = modulator.getType() === 'LFO' ? 0 : 4;
    let x2 = 15 + (modulator.number - 1) * 33 + 33 * factor;
    let y2 = height - 18;
        
    let selected = selectedEdge && selectedEdge.modulator === modulator &&
        selectedEdge.parameter === parameter;
    return (
        <g>
          <line
            onMouseDown={(e) => {
                e.stopPropagation();
                setSelectedEdge({modulator, parameter});
            }}
            x1={x1} y1={y1} x2={x2} y2={y2} strokeWidth={4} opacity={0} stroke={color}/>
          <line
            onMouseDown={(e) => {
                e.stopPropagation();
                setSelectedEdge({modulator, parameter});
            }}
            className={selected ? "mod-edge selected" : selectedEdge ? "mod-edge hidden" : "mod-edge"} x1={x1} y1={y1} x2={x2} y2={y2} strokeWidth={2} stroke={color}/>
        </g>
    );
}

const mapStateToProps = (state, props) => {
    if (!props.parameter) {
        return {};
    }
    return {
      lfos: props.parameter.lfos.length,
      envelopes: props.parameter.envelopes.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModEdges);
